<template>
  <div>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="110px" class="demo-ruleForm">
      <el-form-item label="活动申报方式" prop="campaignway">
        <el-radio-group
          v-model="ruleForm.campaignway"
          class="acDeclaration"
          :disabled="(isInMyActivityPage || (isInTemplate && !isInAddTemplate)) ? true : false"
          @change="onDeclaWayChange">
          <template v-for="(item, index) in declareWay">
            <el-radio v-if="item.show" :label="item.value" :key="index" @change="getHcmApprovalTempletByType(item.value)">
              {{ item.title }} &nbsp;
              <el-popover class="drawer-pop" placement="top" width="300" trigger="hover">
                <span>{{ item.tip }}</span>
                <div slot="reference">
                  <i class="el-icon-warning-outline"></i>
                </div>
              </el-popover>
            </el-radio>
          </template>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="isDealer && !isInTemplate" label="申请店铺" prop="shop_id">
        <el-select
          size="small"
          :multiple="!isInMyActivityPage && ruleForm.campaignway !== 1 ? true : false"
          @change="onShopChange"
          :disabled="needDiabled"
          v-model="ruleForm.shop_id"
          placeholder="请选择"
          style="width: 425px"
          filterable
          >
          <el-option
            v-for="item in getDealerShops"
            :key="item.id"
            :label="item.platform_name + '-' + item.shop_name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-row v-if="!isInTemplate">
        <el-col :span="24">
          <el-form-item label="活动主题" prop="campaign_name">
            <el-input
              style="width:425px;"
              :disabled="needDiabled"
              size="small"
              v-model="ruleForm.campaign_name"
              maxlength="50"
              placeholder="请控制在50字以内">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="preheating_time" label="预热时间">
            <el-date-picker
              :disabled="needDiabled"
              size="small"
              type="datetime"
              placeholder="选择日期"
              value-format="yyyy-MM-dd HH:mm:ss"
              v-model="ruleForm.preheating_time"
              style="width: 425px;">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item v-if="!isInTemplate" label="活动时间" prop="times">
        <el-date-picker
          :disabled="needDiabled"
          style="width: 425px"
          v-model="times"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          size="small"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="onDatePickerChange">
        </el-date-picker>
        <el-row>
          <el-col :span="24" v-for="(item, index) in ruleForm.times" :key="index">
            {{ item }} &nbsp;&nbsp;
            <span v-if="!needDiabled" @click="onDeleteTime(index)" style="color: red;cursor: pointer">删除</span>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item v-if="!isInTemplate" label="活动说明" prop="campaign_desc">
        <el-input
          :disabled="needDiabled"
          style="width:425px;"
          resize="vertical"
          size="small"
          type="textarea"
          show-word-limit
          rows="4"
          maxlength="200"
          placeholder="请控制在200字以内"
          v-model="ruleForm.campaign_desc">
        </el-input>
      </el-form-item>
      <el-form-item v-if="!isInTemplate" label="附件" prop="attachment">
        <el-upload
          ref="upload"
          class="upload-size"
          name="file"
          :with-credentials="true"
          action="hcm/hcmWorkOrder/headUpload"
          :before-upload="handleBeforeUpload"
          :on-remove="handleRemove"
          :on-success="handleUploadSuccess"
					:before-remove="handleBeforeRemove"
          multiple
          :file-list="fileList"
          :data="uploadType">
          <el-button :disabled="needDiabled" size="small" type="plain">
            <i class="el-icon-upload el-icon--right" />
            上传文件
          </el-button>
          <span class="g-block" style="line-height:0.2;color:#999;margin-top: 20px" slot="tip">
            支持扩展名:.rar .zip .doc .docx .xls .xlsx .ppt .pptx .pdf .jpg .png
          </span>
        </el-upload>
      </el-form-item>
      <el-form-item label="活动模板" v-if="ruleForm.campaignway !== 2 && !isInTemplate">
        <el-select
          :disabled="needDiabled"
          v-model="selectTemplateId"
          clearable
          size="small"
          placeholder="请选择活动模板"
          @change="ShopGetById"
          style="width: 425px;"
        >
          <el-option v-for="item in activityDecalareTemplateList"
            :key="item.id"
            :label="item.templatename"
            :value="item.id">
          </el-option>
        </el-select>
        <span class="g-margin-left" @click="onCreateNewTemplate" style="color: #108cee;cursor:pointer">新建模板</span>
      </el-form-item>

      <el-form-item label="活动形式" :required="true" v-if="ruleForm.campaignway === 2 && !isInTemplate">
        <el-radio v-model="radioType" label="1" :disabled="!canEdit || (canEdit && discountsDisabled) ? true : false">打折</el-radio>
        <el-radio v-model="radioType" label="2" :disabled="!canEdit || (canEdit && discountsDisabled) ? true : false">满减</el-radio>
        <el-radio v-model="radioType" label="3" :disabled="!canEdit || (canEdit && discountsDisabled) ? true : false">每满减</el-radio>
      </el-form-item>

      <el-form-item
        label="折扣力度"
        v-if="ruleForm.campaignway === 2 && !isInTemplate && radioType == 1">
        <el-input-number
          v-model="ruleForm.discounts"
          :disabled="!canEdit || (canEdit && discountsDisabled) ? true : false"
          style="width: 278px"
          size="small"
          :precision="2"
          :step="0.01"
          :controls="false"
          :max="10"
          :min="0.01">
        </el-input-number>
        <el-popover class="drawer-pop" placement="right" width="250" trigger="hover">
          <span>本次活动中店铺所有商品都打统一折扣</span>
          <div slot="reference">
            <i class="el-icon-warning-outline"></i>
          </div>
        </el-popover>
      </el-form-item>

      <el-form-item
        label="满减力度"
        v-if="ruleForm.campaignway === 2 && !isInTemplate && radioType == 2">
        满
        <el-input-number
          v-model="cashbacknumone"
          :disabled="!canEdit || (canEdit && discountsDisabled) ? true : false"
          style="width: 100px;margin-left: 22px;margin-right: 8px;"
          size="small"
          :precision="2"
          :step="0.00"
          :controls="false"
          :max="1000000"
          :min="0.00">
        </el-input-number>
        减
        <el-input-number
          v-model="cashbacknumtwo"
          :disabled="!canEdit || (canEdit && discountsDisabled) ? true : false"
          style="width: 100px;margin-left: 8px;"
          size="small"
          :precision="2"
          :step="0.00"
          :controls="false"
          :max="1000000"
          :min="0.00">
        </el-input-number>
      </el-form-item>

      <el-form-item
        label="每满减力度"
        v-if="ruleForm.campaignway === 2 && !isInTemplate && radioType == 3">
        每满
        <el-input-number
          v-model="eachcashbackone"
          :disabled="!canEdit || (canEdit && discountsDisabled) ? true : false"
          style="width: 100px;margin-left: 8px;;margin-right: 8px;"
          size="small"
          :precision="2"
          :step="0.00"
          :controls="false"
          :max="1000000"
          :min="0.00">
        </el-input-number>
        减
        <el-input-number
          v-model="eachcashbacktwo"
          :disabled="!canEdit || (canEdit && discountsDisabled) ? true : false"
          style="width: 100px;margin-left: 8px;"
          size="small"
          :precision="2"
          :step="0.00"
          :controls="false"
          :max="1000000"
          :min="0.00">
        </el-input-number>
      </el-form-item>

      <el-form-item label="审批结果" v-if="isInMyActivityPage && ruleForm.campaignway === 2 && !canEdit">
        <slot></slot>
      </el-form-item>
      <el-form-item v-if="isInTemplate" label="模板名称" prop="templatename">
        <el-input
          :disabled="needDiabled"
          style="width:425px;"
          size="small"
          placeholder="请输入"
          v-model="ruleForm.templatename">
        </el-input>
      </el-form-item>
      <el-form-item v-if="ruleForm.campaignway !== 2" :label="ruleForm.campaignway === 0 ? '活动产品' : '活动链接'" prop="products">
        <div class="addFont" v-if="ruleForm.campaignway === 0" :disabled="needDiabled" @click="onAddProduct" style="width: 425px">
          <i class="el-icon-plus"></i>
          添加活动产品
        </div>
        <div v-if="ruleForm.campaignway === 1">
          <el-button :disabled="needDiabled" @click="onDownloadTemplate" size="small" type="plain">下载模板表格</el-button>
          <el-upload
            style="display: inline-block;margin-left: 10px"
            class="upload-demo"
            action=""
            :disabled="needDiabled"
            :before-upload="onUplodaExcel">
          <el-button :disabled="needDiabled" size="small" type="plain">导入模板表格</el-button>
          </el-upload>
        </div>
      </el-form-item>
    </el-form>
    <Comfirm
      :visible="visible"
      title="保留或者替换原数据"
      @on-close="visible = false"
      @on-comfirm="onPassData"
    >
      <template v-slot:content>
        <el-radio v-model="radio" label="1">替换</el-radio>
        <el-radio v-model="radio" label="2">保留</el-radio>
      </template>
    </Comfirm>
    <el-dialog
      title="提示"
      :visible.sync="deleteShow"
      width="640px"
      :close-on-click-modal="false"
    >
    <div style="font-size: 14px;max-height: 640px;overflow-y: auto">
      <div style="display: flex;width: 100%;margin-bottom: 16px;">
        <i class="el-icon-warning" style="color:#faad14;font-size: 24px;"></i>
        <div>
          <div style="font-weight: bold;margin-left: 15px;">当前使用模板中的存在活动产品不可用：</div>
        </div>
      </div>
      <div v-for="item in deleteArray" style="margin-bottom: 32px;">
        <div style="margin: 8px 0 0 40px;">{{item.productInfo}}</div>
      </div>
      <div>
        <div style="margin-left: 40px;color: red;">系统已自动删除本产品的活动信息</div>
      </div>
      <div>
        <div style="margin: 8px 0 0 40px;color: #999;">不可用原因：产品信息已不存在，或已被删除</div>
      </div>
    </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="deleteShow=false">我知道了</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Comfirm from 'components/comfirmDialog/comfirmDialog.vue'
import ActivityMixin from '@/mixins/activityMixin'
import xlsx from 'xlsx';
import { mapState, mapGetters, mapActions } from 'vuex';
import _ from 'lodash';
export default {
  name: 'activityForm',

  mixins: [
    ActivityMixin
  ],

  components:{
    Comfirm
  },

  props: {
    discountsDisabled: {
      type: Boolean
    },
    isInTemplate: {
      type: Boolean,
      default: false
    },
    canEdit: {
      type: Boolean,
    },
    needDiabled: {
      type: Boolean
    },
    isInMyActivityPage: {
      type: Boolean,
      default: false
    },
    isInAddTemplate: {
      type: Boolean,
      default: false
    },
    productsArr: {
      type: Array
    },
    ruleForm: {
      type: Object,
      default: () => {
        return {
          preheating_time: '',
          campaignway: 0,
          campaign_name: '',
          times: [],
          campaign_desc: '',
          shop_id: [],
          attachment: '',
        }
      }
    }
  },

  watch: {
    getActivityInfoDetail() {
      this.newConData = this.getActivityInfoDetail.list[0]
      if (this.newConData.discounts) {
        this.ruleForm.discounts = this.newConData.discounts
        this.radioType = '1'
      }
      if (this.newConData.cashbacknumone || this.newConData.cashbacknumtwo) {
        this.cashbacknumone = this.newConData.cashbacknumone
        this.cashbacknumtwo = this.newConData.cashbacknumtwo
        this.radioType = '2'
      }
      if (this.newConData.eachcashbackone || this.newConData.eachcashbacktwo) {
        this.eachcashbackone = this.newConData.eachcashbackone
        this.eachcashbacktwo = this.newConData.eachcashbacktwo
        this.radioType = '3'
      }
    }
  },

  data () {
    const validateShopid = (rule, value, callback) => {
      if(!value || value.length === 0) {
        callback(new Error('请选择店铺'));
      }else {
        callback()
      }
    };
    return {
      uploadType: {
        tong: 'activityForm'
      },
      newConData: [],
      cashbacknumone: 0,
      cashbacknumtwo: 0,
      eachcashbackone: 0,
      eachcashbacktwo: 0,
      radioType: '1',
      declareWay: [
        { value: 0, title: '按产品申报', tip: '必须选择产品来申报活动，可不填写产品链接', show: true },
        { value: 1, title: '按链接申报', tip: '必须填写链接来申报活动，可不选择产品型号', show: true },
        { value: 2, title: '全店铺申报', tip: '全店产品都做活动，只需填写折扣力度', show: true },
      ],
      deleteArray: [],
      deleteShow: false,
      isDealer: false,
      excelData: [],
      radio: '1',
      visible: false,
      subimitKeys: [
        'preheating_time',
        'campaignway',
        'campaign_name',
        'times',
        'campaign_desc',
        'shopname',
        'discounts',
        'attachment',
        'shop_id',
      ],
      times: [],
      selectTemplateId: '',
      rules: {
        shop_id: [
          { required: true, validator: validateShopid, trigger: 'change' }
          // { required: true, message: '请选择申请店铺', trigger: 'blur' },
          // { type: 'array', required: true, message: '请选择申请店铺', trigger: 'blur' },
        ],
        templatename: [
          { required: true, message: '请输入模板名称', trigger: 'blur' },
        ],
        times: [
          { type: 'array', required: true, message: '请选择活动时间', trigger: 'change' }
        ],
        campaignway: [
          { required: true, message: '请选择活动主题方式', trigger: 'change' },
        ],
        shopname: [
          { required: true, message: '请选择申请店铺', trigger: 'change' },
        ],
        campaign_name: [
          { required: true, message: '请输入活动主题', trigger: 'blur' },
        ],
        campaign_desc: [
          { required: true, message: '请填写活动说明', trigger: 'blur' }
        ]
      },
      acceptFileFormat: [
        '.rar', '.zip', '.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.pdf', '.jpg', '.png'
      ],
      uploadFileList: [],
      fileList: [],
      processmodel: '',
    }
  },

  methods: {
    async onShopChange(id) {
      console.log(id);
      let params
      this.selectTemplateId = "";
      if(id && typeof id === 'string') {
        params = {
          shopid: id,
          platform: (this.getDealerShops.find(item => item.id === id)).platform_code
        }
      }else if(Array.isArray(id) && id.length) {
        const platforms = [];
        this.getDealerShops.forEach(item => {
          if(id.includes(item.id) && !platforms.includes(item.platform_code)) {
            platforms.push(item.platform_code)
          }
        })
        params = {
          shopid: id.join(','),
          platform: platforms.join(',')
        }
      }

      // const productData = await this.reqActivityShopProduct(params)
      // this.$emit('on-change-shop', productData)
      this.$emit('on-change-shop', productData)
    },
    ...mapActions([
      'reqActivityShopProduct',
      'reqActivityDecalareTemplateList',
      'reqActivityFlowWay'
    ]),
    onDownloadTemplate() {
      let url = `hcm/campgign/exportExcel`;
      window.open(url);
    },
    onPassData() {
      this.$emit('on-excel-data', {
        excelData: this.excelData,
        flag: this.radio
      });
      this.visible = false;
    },
    transKeyToEnglish(key) {
      if(key === '产品型号') {
        return 'productInfo'
      }
      for(const item of this.getActivitySetting) {
        const children = item.children;
        const child = children.find(child => child.fieldname === key);
        if(child) {
          return child.fieldvalue;
        }
      }
    },
    // 处理导入的excel数据
    handleExcelData(data){
      const res = [];
      const headerData = [];
      const targetSheetName = data.SheetNames[0];
      const targetSheet = data.Sheets[targetSheetName];
      for(const key of Object.keys(targetSheet)) {
        if(/[A-Z]+/.test(key)) {
          const num = parseInt(key.match(/\d+/)[0]);
          if(num === 1) {
            headerData.push({
              key: key.match(/[A-Z]+/)[0],
              resKey: this.transKeyToEnglish(targetSheet[key]['v'])
            })
          }else {
            const rowIndex = num - 2;
            const item = headerData.find(item => key.indexOf(item.key) !== -1);
            const row = res[rowIndex];
            if(!item) {
              return;
            }
            if(row) {
              row[item.resKey] = targetSheet[key]['v'];
            }else {
              const obj = {};
              obj[item.resKey] = targetSheet[key]['v'];
              res.push(obj)
            }
          }
        }
      }
      console.log(res);

      this.excelData = res;
      if(this.productsArr.length) {
        this.visible = true;
      }else {
        this.onPassData();
      }
		},
		handleBeforeRemove() {
			if(!this.canEdit) {
				this.$message.error('当前状态不可删除文件')
				return false;
			}

			return true;
		},
    // 上传excel，获取里面的数据
    onUplodaExcel(file) {
      const reader = new FileReader()
      reader.readAsBinaryString(file)
      reader.onload = (event) => {
        let workbook = xlsx.read(event.target.result, {type: 'binary'})
        console.log(workbook);
        this.handleExcelData(workbook);
      }
      return false
    },
    validForm() {
      return new Promise(r => {
        this.$refs['ruleForm'].validate((valid) => {
          if(valid) {
            if(this.ruleForm.preheating_time) {
              if((new Date(this.ruleForm.preheating_time)).getTime() > (new Date(this.ruleForm.times[0].split('~')[0])).getTime()) {
                this.$message.warning('活动开始时间需要大于预热时间');
                r(false);
              }
            }
            if(this.isInMyActivityPage && this.ruleForm.times.length > 1) {
              this.$message.warning('再次申报时间');
              r(false);
            }
            r(true);
          }else {
            r(false);
          }
        })
      })
    },
    getHcmApprovalTempletByType(value) {
      console.log(123)
      console.log(value)
      let type = value
      let params={
        type: 'CAM',
        declaremeans: type
      }
      fetch({
        url: "hcm/hcmApproval/getHcmApprovalTempletByType",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let {data}=res
        if(res.status == '10000'){
          this.processmodel = data.processmodel
        }
      }).catch(err => {

      })
    },
    getFormData() {
      console.log(_.cloneDeep(this.ruleForm));

      const copyData = _.cloneDeep(this.ruleForm);
      const finalData = {};
      for(const key of this.subimitKeys) {
        if(copyData[key] || key === 'campaignway') {
          if(!this.isInMyActivityPage && this.isDealer && key === 'shop_id') {
            finalData.shopids = Array.isArray(copyData[key]) ? copyData[key].join(',') : copyData[key];
          }else {
            finalData[key] = copyData[key]
          }
        }
      }
      delete finalData.discounts;
      if(this.isInMyActivityPage) {
        const times = finalData.times[0].split('~');
        finalData.start_time = times[0];
        finalData.end_time = times[1];
        delete finalData.times;
      }

      if(this.getUserLoginType !== 'DEALER') {
        delete finalData.shop_id;
      }
      if (this.radioType == 1) {
        finalData.discounts = this.ruleForm.discounts
      } else if (this.radioType == 2) {
        finalData.cashbacknumone = this.cashbacknumone
        finalData.cashbacknumtwo = this.cashbacknumtwo
        finalData.cashback = '满' + this.cashbacknumone + '减' + this.cashbacknumtwo
      } else if (this.radioType == 3) {
        finalData.eachcashbackone = this.eachcashbackone
        finalData.eachcashbacktwo = this.eachcashbacktwo
        finalData.eachcashback = '每满' + this.eachcashbackone + '减' + this.eachcashbacktwo
      }
      finalData.campaignmodel = this.processmodel
      return finalData;
    },
    onDeclaWayChange(val) {
      if(val !== 2) {
        this.reqActivityDecalareTemplateList({
          pageNo: 1,
          pageSize: 10000,
          declaremeans: String(val)
        })
      }

      if(!this.isInTemplate) {
        if(val === 1) {
          this.ruleForm.shop_id = '';
        }else {
          this.ruleForm.shop_id = [];
        }
      }


      this.$emit('on-way-change', val);
    },
    onDeleteTime(index) {
      this.ruleForm.times.splice(index, 1);
    },
    onDatePickerChange(timeArr) {
      if(timeArr) {
        if(this.isInMyActivityPage && this.ruleForm.times.length === 1) {
          this.$message.error('再次申报时间只能选择一个');
          return;
        }
        if(new Date(timeArr[0]).getTime() < new Date().getTime()) {
          this.$message.error('活动时间不能低于当前系统时间');
        }else {
          const times = timeArr.join('~')
          this.ruleForm.times.push(times);
          this.sortTime();
        }
        this.times = [];
      }
    },
    sortTime() {
      // 去重
      const timeArr = [...new Set(this.ruleForm.times)];
      // 排序
      this.ruleForm.times = timeArr.sort((a, b) => (new Date(a.split('~')[0]).getTime() - new Date(b.split('~')[0]).getTime()))
    },
    onAddProduct() {
      this.$emit('on-change-shop')
      this.$emit('on-add-product');
    },
    handleBeforeUpload(file) {
      const suffix = file.name.substring(file.name.lastIndexOf('.'));
      let isAcceptFile = false;
      for(let i of this.acceptFileFormat) {
        if(i === suffix) {
          isAcceptFile = true;
        }
      }
      if (!isAcceptFile) {
        this.$message.error('请上传符合格式的文件!');
      }
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isLt50M) {
        this.$message.error('上传文件大小不能超过 50MB!');
      }
      return isLt50M && isAcceptFile;
    },
    // 上传附件成功的回调
    handleUploadSuccess(res) {
      this.uploadFileList.push(res.data.data);
      this.ruleForm.attachment = this.uploadFileList.join(',');
		},
		echoAttachments(attachment) {
			const files = attachment.split(',');
			this.uploadFileList = files;
			this.fileList = files.map(name => {
				return { name: name.slice(name.indexOf('_') + 1), response: {
					data: {
						data: name
					}
				} }
			})
		},
    // 移除上传的文件
    handleRemove(file, fileList) {
      let res = [];
      for(let i of fileList) {
        res.push(i.response.data.data);
      }
      this.uploadFileList = res;
      this.ruleForm.attachment = this.uploadFileList.join(',');
    },
    // 获取平台、ID
    ShopGetById() {
      let params = {
        shopId: this.ruleForm.shop_id.join(',')
      }
      fetch({
        url: "hcm/hcmShop/getById",
        method: "get",
        noFormat: true,
        params: params,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let {data}=res
        if(res.status == '10000'){
          this.getListBybmcid(res.data.platformCode,res.data.id)
        }
      }).catch(err => {

      })
    },
    // 获取产品数据
    getListBybmcid(platform,shopid) {
      let params={
        platform: this.$route.query.id,
        shopid: this.childmonitortime
      }
      fetch({
        url: "hcm/hcmProduct/getListBybmcid",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let {data}=res
        if(res.status == '10000'){
          this.onTemplateChange(res.data)
        }
      }).catch(err => {

      })
    },
    // 赋值并且筛选被删除掉的数据
    onTemplateChange(data) {
      if(this.selectTemplateId) {
        this.reqActivityDecalareTemplateDetail({
          id: this.selectTemplateId
        }).then(res => {
          const templateData = this.handleTemplateData(res);
          console.log('====================================');
          console.log(templateData);
          let arrCid = []
          this.deleteArray = []
          for (let a in data) {
            for (let b in data[a].children) {
              if (data[a].children[b].id.split(',')[0]) {
                arrCid.push(data[a].children[b].id.split(',')[0])
              }
            }
          }
          for (let c in templateData) {
            if(arrCid.indexOf(templateData[c].product_id) == -1){
              this.deleteArray.push(templateData[c])
              templateData.splice(c, 1)
            }
          }
          console.log(this.deleteArray)
          if (this.deleteArray.length > 0) {
            this.deleteShow = true
          }
          console.log('====================================');
          templateData.length && this.$emit('on-add-template-data', templateData);
          // this.products = this.products.concat(templateData);
        })
      }
    },
    onCreateNewTemplate() {
      this.$router.push('/Brand/floatingPlaten/main')
		},
		setDeclareWay(index) {
			this.declareWay[index].show = true
		},
    async controlDeclareWay() {
      if(this.$route.path.indexOf('addMain') === -1) {
        const res = await this.reqActivityFlowWay();
        this.declareWay[0].show = res['campaignproduct'] === 1;
        this.declareWay[1].show = res['campaignlink'] === 1;
        this.declareWay[2].show = res['campaignshop'] === 1;
      }else {
        this.declareWay[2].show = false;
      }

    }
  },

  computed: {
    ...mapGetters([
      'getActivitySetting',
      'getDealerShops',
      'getUserLoginType',
      'getActivityInfoDetail',
    ]),
    ...mapState({
      activityDecalareTemplateList: state => state.activityDeclaration.activityDecalareTemplateList
    })
  },

  async mounted(){
    this.isDealer = this.getUserLoginType === 'DEALER' ? true : false;
    this.controlDeclareWay()
    this.getHcmApprovalTempletByType(0)
  }
}
</script>
<style lang="scss">
  .addFont {
    color: #108cee;
    font-weight: bold;
    text-align: center;
    border: 1px dashed #e8ebec;
    height: 30px;
    width: 425px;
    line-height: 30px;
    cursor: pointer;
  }
  .addFont:hover {
    border: 1px dashed #108cee;
  }
</style>
